<div class="search-bar-container">
  <div class="search-bar">
    <input
      [(ngModel)]="filterText"
      type="text"
      placeholder="Pesquise pelo CRM, nome, UF, situação ou especialidade do médico"
      (keyup.enter)="onFilterSearch()" />
    <div class="search-icon-container" (click)="onFilterSearch()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>
  <button *ngIf="hasAccessToRegisterPractitioner()" mat-flat-button class="add-btn" (click)="goToRegisterPractitioner()">ADICIONAR MÉDICO</button>
</div>
<div *ngIf="!hasPractitioners()">
  <p>Nenhum resultado encontrado.</p>
</div>
<div *ngIf="hasPractitioners()" class="practitioner-card-container">
  <div *ngFor="let practitioner of getPractitioners()" class="card-container">
    <div class="img-container">
      <img src="./assets/icons/practitioner-icon 2.svg" />
    </div>
    <div class="data-container">
      <div class="row-1">
        <span>{{ practitioner.getName() }}</span>
      </div>
      <div class="row-2">
        <div class="data">
          <span class="value">UF: {{ practitioner.getStateAcronym().getValue() }}</span>
        </div>
        <div class="data">
          <span class="value">CRM: {{ practitioner.getRegistration() }}</span>
        </div>
        <div class="data">
          <span class="value">Situação: {{ practitioner.getStatus().getDescription() }}</span>
        </div>
        <div class="data">
          <span class="value"
            >Especialidade:
            {{ practitioner.getSpecialtiesSearchView() }}
            <div *ngIf="practitioner.hasMoreThanOneSpecialty()" class="specialty-count-circle">
              <span>{{ practitioner.getSpecialtyCountView() }}</span>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="action-container">
      <button  mat-flat-button (click)="goToEditPractitioner(practitioner)">
        <mat-icon aria-hidden="false">{{ hasAccessToEditPractitioner() ? "edit_note" : "visibility" }}</mat-icon
        >{{ hasAccessToEditPractitioner() ? "EDITAR" : "VISUALIZAR" }}
      </button>
      <button *ngIf="hasAccessToEditPractitioner()" mat-flat-button class="delete-btn" (click)="deletePractitioner(practitioner)">
        <mat-icon aria-hidden="false">clear</mat-icon>DELETAR
      </button>
    </div>
  </div>
  <div fxLayoutAlign="end center">
    <a class="more-registers-btn" *ngIf="showMoreResultsBtn()">
      <span (click)="searchMore()">carregar mais registros</span>
    </a>
  </div>
</div>
